import React from 'react'
import { observeActivity } from '../lib/viewport-activity'

import Wave from '../components/wave'
import './wavesection.css'

import Typing from '../lib/typing.js'
import '../lib/typing.css'
import { contentfulImageSrcSet, contentfulImageUrl } from '../lib/contentful-image'

class WaveSection extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            typing_delay: 250
        }
    }

    handleTyping = () => {
        this.typedText = this.props.text
        const text = this.textElement
        if (text) {
            if (this.typing) {
                this.typing.destroy()
            }
            let buf_text = document.createElement("div")
            buf_text.textContent = this.props.text
            text.textContent = "";
            this.typing = new Typing({
                source: buf_text,
                output: text,
                delay: this.state.typing_delay,
                done: function() {

                } //完成打印后的回调事件
            });
            this.typing.start()
        }
    }

    componentDidMount() {
        this.typingEnabled = !(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent))
        this.stopObserving = observeActivity(this.container, active => {
            this.active = active
            if (this.props.onActivityChange) this.props.onActivityChange(this.props.index, active)
            if (active) {
                // React keeps the latest props even when an offscreen render is
                // skipped. Catch up once on entry, preserving the shared rotation.
                this.forceUpdate(() => {
                    if (!this.typingEnabled) return
                    if (!this.typing || this.typedText !== this.props.text) this.handleTyping()
                    else this.typing.resume()
                })
            } else if (this.typing) this.typing.pause()
        })
        this.handleFocus = () => {
            if (this.active && this.typing) this.typing.resume()
        }
        this.handleBlur = () => {
            if (this.typing) this.typing.pause()
        }
        window.addEventListener('focus', this.handleFocus)
        window.addEventListener('blur', this.handleBlur)
    }

    shouldComponentUpdate(nextProps) {
        return this.active && (
            nextProps.image !== this.props.image ||
            nextProps.logo !== this.props.logo ||
            nextProps.text !== this.props.text
        )
    }

    componentDidUpdate(prevProps) {
        if (this.typingEnabled && prevProps.text !== this.props.text) {
            if (this.active) this.handleTyping()
            else if (this.typing) {
                this.typing.destroy()
                this.typing = null
            }
        }
    }

    componentWillUnmount() {
        this.stopObserving()
        if (this.props.onActivityChange) this.props.onActivityChange(this.props.index, false)
        window.removeEventListener('focus', this.handleFocus)
        window.removeEventListener('blur', this.handleBlur)
        if (this.typing) this.typing.destroy()
    }


    render() {
        return (
            // <div className="WaveSectionGroup" style={{ backgroundImage: "url(" + this.props.image + ")"}}>
            <div className="WaveSectionGroup" ref={element => { this.container = element }}>
                <img
                    className="WaveSectionbg"
                    src={contentfulImageUrl(this.props.image, 1280)}
                    srcSet={contentfulImageSrcSet(this.props.image, [640, 960, 1280, 1600])}
                    sizes="100vw"
                    loading="lazy"
                    decoding="async"
                    alt=""
                />
                <div className="WaveTop">
                    {/* <Wave waveheight="120" /> */}
                    <Wave />
                </div>
                <div className="WaveBottom">
                    {/* <Wave waveheight="120" /> */}
                    <Wave />
                </div>
                <img
                    className="WaveSectionLogo"
                    src={contentfulImageUrl(this.props.logo, 300)}
                    srcSet={contentfulImageSrcSet(this.props.logo, [150, 300])}
                    sizes="150px"
                    draggable="false"
                    loading="lazy"
                    decoding="async"
                    alt=""
                />
                <div className="WaveSectionTitleGroup">
                    <p className="Decoration left">/*</p>
                    <p className="WaveSectionText" ref={element => { this.textElement = element }}>{this.props.text}</p>
                    {/* <span class="typing-cursor-white">|</span> */}
                    <p className="Decoration right">*/</p>
                </div>
            </div>
        )
    }
}

export default WaveSection
